import { collection, query, where, orderBy, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

export const obtenerHistorialDeOrden = async (orderId) => {
  const logsRef = collection(db, process.env.REACT_APP_COL_XPRESSLOGS);

  const q = query(logsRef, where("orderId", "==", orderId));

  const snap = await getDocs(q);

  const historial = snap.docs.map((docSnap) => ({
    id: docSnap.id,
    ...docSnap.data(),
  }));

  return historial;
};
